<template>
    <div>
        <v-dialog v-model="dialoginfoError" persistent width="330px">
            <v-card class="text-center align-center justify-center pa-6" width="330px" style="border-radius: 30px;">
                <v-avatar class="color-avataralert my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                {{ alert_err }}
                </div>
                <div class="align-center justify-center mt-2">
                {{ alert_err_attention }}
                </div>
            </v-card>
        </v-dialog>
        
     </div>
     
</template>
<script>
export default {
    data() {
        return {
            alertbar:false,
            dialoginfoError: false,
            alert_err: "",
            alert_err_attention: "",
        }
    },
   methods: {
        async error_response(status,messages){
            if(status == 204){
                this.dialoginfoError = true;
                this.alert_err =  'Error';
                this.alert_err_attention = messages;
                setTimeout(() => {
                        this.dialoginfoError = false;
                }, 2000);
            }
        },

        async error_login(status){
            // alert(status);
            if(status == 200){
                this.dialoginfoError = true;
                this.alert_err =  'Error';
                this.alert_err_attention = "Sorry, you haven't logged in yet";
                setTimeout(() => {
                        this.dialoginfoError = false;
                        this.$router.push('/');
                }, 2000);
                // jika belum login local storage wajib dihapus
                localStorage.removeItem('username');
                localStorage.removeItem('token_app');
                localStorage.removeItem('email');
                localStorage.removeItem('authmenu');
                localStorage.removeItem('module');
                localStorage.removeItem('not_access');

                localStorage.removeItem('authactinsert');
                localStorage.removeItem('authactupdate');
                localStorage.removeItem('authactdelete');
                localStorage.removeItem('authactview');
                localStorage.removeItem('menuPrivilage');
            }else{
                this.dialoginfoError = true;
                this.alert_err =  'Error';
                this.alert_err_attention = 'Sorry, your login session has expired, please log in again.';
                setTimeout(() => {
                    this.dialoginfoError = false;
                    this.$router.push('/');
                }, 2000);
                // jika belum login local storage wajib dihapus
                localStorage.removeItem('username');
                localStorage.removeItem('token_app');
                localStorage.removeItem('email');
                localStorage.removeItem('authmenu');
                localStorage.removeItem('module');
                localStorage.removeItem('not_access');

                localStorage.removeItem('authactinsert');
                localStorage.removeItem('authactupdate');
                localStorage.removeItem('authactdelete');
                localStorage.removeItem('authactview');
                localStorage.removeItem('menuPrivilage');
            }

        },
         alertPopup(status,messages,url){
            if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                
                this.$router.push(url);
            }else{
                this.alertFailed = true;
                this.alert_err_attention =  messages;
                
                this.$router.push(url);
                
            }

        }
   }
}
</script>

<style scoped>
.v-avatar.color-avataralert {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>